<div class="PGEmail input-group">
        <input [id]="fieldId" class="form-control" [disabled]="readonly" [required]="required" [(ngModel)]="value" (ngModelChange)="onValueChange()"/>
</div>